// Fixed-width stack for the prompt-body editors. Prompt bodies are trusted, verbatim text, so
// tokens and whitespace read exactly as authored. The design system has no monospace font token, so
// this stack is shared here and applied only as a font-family override — the font size stays the
// design system's input font, so a monospace field reads at the same text size as the others.
export const NOVA_MONOSPACE_FONT = "'SFMono-Regular', Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace";
